import { useNavigate } from 'react-router-dom'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import {
  ProjectionKind,
  TrainingsDataTableQuery,
  useTrainingsDataTable,
} from 'generated/resources/datatable.graphql'

import DataTable, { useDataTable } from 'modules/core/components/DataTable'
import Sidepanel from 'modules/core/components/Sidepanel'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { dateFilter } from 'modules/trainings/components/CatalogComponent/CatalogDatatable/dateFilter'
import { competenciesFilter } from 'modules/trainings/components/TrainingsDataTable/competenciesFilter'
import { useCompetencies } from 'modules/trainings/hooks/Trainings/useCompetencies'
import { useUpdateCatalog } from 'modules/trainings/hooks/Trainings/useUpdateCatalog'

export const SelectTrainingComponent = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()
  const { competencies } = useCompetencies()
  const source = useTrainingsDataTable(
    [
      {
        identifier: 'name',
        kind: ProjectionKind.Path,
        title: i18n.t('trainings.trainings_table.name'),
        path: 'name',
      },
    ],
    { variables: { catalog: false, search: debouncedSearch, status: 'active' } }
  )

  return (
    <DataTable.Provider
      source={source}
      filters={[dateFilter(source), competenciesFilter(source, 'SelectCatalogTable', competencies)]}
      pagination={{
        kind: 'offset',
        itemsPerPage: 100,
      }}
    >
      <Sidepanel
        open
        width="wide"
        title={i18n.t('trainings.training_catalog.select.title')}
        footer={<Footer />}
        onClose={() => navigate(navigation.trainings.catalog.list.fullPath())}
      >
        <Box gap="s8">
          <Text size="300" color="grey800" weight="normal">
            {i18n.t('trainings.training_catalog.select.description')}
          </Text>
          <DataTable.HeadBar
            search={{
              placeholder: i18n.t('common.search'),
              value: search,
              onChange: onSearch,
            }}
            disableExport
          />
          <DataTable.Table selectable={() => true} />
        </Box>
      </Sidepanel>
    </DataTable.Provider>
  )
}

const Footer = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const data = useDataTable<TrainingsDataTableQuery>()
  const selectedRows = [...data.selectedRows].map((id) => +id)
  const { updateCatalog } = useUpdateCatalog()
  const onSubmit = async () => {
    const response = await updateCatalog({ ids: selectedRows, catalog: true })

    const handled = handleResult(response, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.training_catalog.select.error'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('trainings.training_catalog.select.added'),
      })

      navigate(navigation.trainings.catalog.list.fullPath())
    }
  }
  return (
    <Box flexDirection="row" gap="s8">
      <Button.Router type="secondary" to={navigation.trainings.catalog.list.fullPath()}>
        {i18n.t('common.cancel')}
      </Button.Router>
      <Button disabled={selectedRows.length === 0} onClick={() => onSubmit()}>
        {i18n.t('common.save')}
      </Button>
    </Box>
  )
}
